/* SERVATI · Three Roads — comportamento della sezione tr-drop-landing
   - conti alla rovescia (drop e sblocchi) con l'orologio del visitatore
   - all'ora di uno sblocco/del drop ricarica SOLO la sezione dal server (Section Rendering API):
     è Liquid a decidere cosa si vede, il JS non svela mai contenuti
   - mosaico che si risolve allo sblocco (anche per chi arriva dall'email entro 24 h)
   - video hero, barra fissa mobile, iscrizione Klaviyo, file calendario, lettore teaser
*/
(function () {
  'use strict';

  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var TZ = 'Europe/Rome';
  var store = {
    get: function (k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }
  };

  function pad(n) { return String(n).padStart(2, '0'); }
  function parts(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    return { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
  }
  function fmt(ts, opts) { return new Intl.DateTimeFormat('it-IT', Object.assign({ timeZone: TZ }, opts)).format(new Date(ts * 1000)); }
  function dayShort(ts) {
    var w = fmt(ts, { weekday: 'short' }).replace('.', '');
    return w.charAt(0).toUpperCase() + w.slice(1) + ' ' + fmt(ts, { day: '2-digit', month: '2-digit' }).replace('/', '.');
  }
  function hhmm(ts) { return fmt(ts, { hour: '2-digit', minute: '2-digit' }); }
  function weekday(ts) { return fmt(ts, { weekday: 'long' }); }
  function nowS() { return Date.now() / 1000; }
  function track(name, data) {
    try { if (window.fbq) window.fbq('track', name, data || {}); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('tr_' + name.toLowerCase(), data || {}); } catch (e) {}
  }

  /* ---------- mosaico ---------- */
  function drawMosaic(cv, img, block) {
    var W = cv.clientWidth || 300, H = cv.clientHeight || 400;
    var w = Math.max(2, Math.round(W / block)), h = Math.max(2, Math.round(H / block));
    cv.width = w; cv.height = h;
    var x = cv.getContext('2d');
    var r = Math.max(w / img.naturalWidth, h / img.naturalHeight), dw = img.naturalWidth * r, dh = img.naturalHeight * r;
    var anchor = cv.closest && cv.closest('.tr-ch-wide') ? 0.5 : 0.18;
    x.drawImage(img, (w - dw) / 2, (h - dh) * anchor, dw, dh);
  }
  function reveal(card) {
    var img = card.querySelector('.tr-ch-img');
    if (!img || RM) return;
    var go = function () {
      var cv = document.createElement('canvas');
      cv.className = 'tr-ch-cv';
      cv.style.filter = 'grayscale(1) brightness(.42)';
      card.querySelector('.tr-ch-m').appendChild(cv);
      var steps = [22, 16, 11, 7, 4, 2], k = 0;
      drawMosaic(cv, img, steps[0]);
      requestAnimationFrame(function () { cv.style.filter = 'none'; });
      (function step() {
        drawMosaic(cv, img, steps[k]);
        if (++k < steps.length) setTimeout(step, 95);
        else { cv.classList.add('is-gone'); setTimeout(function () { cv.remove(); }, 1000); }
      })();
    };
    if (img.complete && img.naturalWidth) go(); else img.addEventListener('load', go, { once: true });
  }

  /* ---------- sezione ---------- */
  function Section(root, opts) {
    this.root = root;
    this.sid = root.dataset.sectionId;
    this.timers = [];
    this.observers = [];
    try { this.cfg = JSON.parse(root.querySelector('[data-tr-config]').textContent); } catch (e) { this.cfg = { next: [] }; }
    this.drop = +root.dataset.drop || 0;
    this.next = +root.dataset.next || 0;
    this.design = root.hasAttribute('data-design-mode');
    // nell'editor con "Simula ora" i conti partono dall'ora simulata
    this.offset = this.design ? (+root.dataset.now - nowS()) : 0;
    this.reloading = false;
    this.subscribed = store.get('tr-sub') === '1';
    this.init(opts || {});
  }
  Section.prototype.now = function () { return nowS() + this.offset; };

  Section.prototype.init = function (opts) {
    var self = this, r = this.root;

    // etichette data in italiano
    r.querySelectorAll('[data-tr-day]').forEach(function (el) { el.textContent = dayShort(+el.dataset.trDay); });
    r.querySelectorAll('[data-tr-when]').forEach(function (el) { var t = +el.dataset.trWhen; el.textContent = 'Si sblocca ' + dayShort(t).toLowerCase() + ' · ' + hhmm(t); });

    this.tick();
    this.timers.push(setInterval(function () { if (!document.hidden) self.tick(); }, 1000));

    // sblocchi appena avvenuti (ricarica in pagina) o recenti (arrivo dall'email)
    var revealKeys = opts.reveal || [];
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        store.set('tr-seen-' + e.target.dataset.key, '1');
        setTimeout(function () { reveal(e.target); }, 200);
      });
    }, { threshold: 0.6 }) : null;
    if (io) this.observers.push(io);
    r.querySelectorAll('.tr-ch[data-state="open"]').forEach(function (c) {
      var k = c.dataset.key;
      if (revealKeys.indexOf(k) > -1) { store.set('tr-seen-' + k, '1'); reveal(c); }
      else if (c.hasAttribute('data-recent') && !store.get('tr-seen-' + k) && io) io.observe(c);
    });

    this.initForms();
    this.initHero();
    this.initSticky();
    this.initPlayer();
    this.initPixelFx();
    r.querySelectorAll('[data-tr-focus-form]').forEach(function (b) { b.addEventListener('click', function () { self.focusForm(); }); });
  };

  Section.prototype.destroy = function () {
    this.timers.forEach(clearInterval);
    this.observers.forEach(function (o) { o.disconnect(); });
    // if (this.heroVideo) this.heroVideo.pause();
    if (this.heroVideo) this.heroVideo.pause();
      if (this.fx) this.fx.forEach(function (f) { f.destroy(); });
      if (this.onResize) window.removeEventListener('resize', this.onResize);
      if (this.onVis) document.removeEventListener('visibilitychange', this.onVis);
  };

  Section.prototype.tick = function () {
    var r = this.root, t = this.now();
    var p = parts((this.drop - t) * 1000);
    var cd = r.querySelector('[data-tr-countdown]');
    if (cd) {
      ['d', 'h', 'm', 's'].forEach(function (u) { var b = cd.querySelector('[data-u="' + u + '"]'); if (b) b.textContent = pad(p[u]); });
      cd.setAttribute('aria-label', 'Il drop apre tra ' + p.d + ' giorni e ' + p.h + ' ore');
    }
    var days = r.querySelector('[data-tr-days]');
    if (days) days.textContent = p.d > 1 ? 'tra ' + p.d + ' giorni' : p.d === 1 ? 'domani alle ' + hhmm(this.drop) : 'oggi alle ' + hhmm(this.drop);
    var st = r.querySelector('[data-tr-stick-t]');
    if (st && r.dataset.phase !== 'drop') st.textContent = 'Apre tra ' + p.d + 'g ' + pad(p.h) + ':' + pad(p.m) + ':' + pad(p.s);
    r.querySelectorAll('[data-tr-unlock-timer]').forEach(function (el) {
      var q = parts((+el.dataset.trUnlockTimer - t) * 1000);
      el.textContent = pad(q.d) + 'G ' + pad(q.h) + ':' + pad(q.m) + ':' + pad(q.s);
      el.setAttribute('aria-label', 'Si sblocca tra ' + q.d + ' giorni, ' + q.h + ' ore e ' + q.m + ' minuti');
    });
    if (this.next && t >= this.next && !this.reloading && !this.design) this.reload();
  };

  // ricarica la sezione dal server; se l'orologio del visitatore era avanti, riprova tra 60 s
  Section.prototype.reload = function () {
    var self = this;
    this.reloading = true;
    var before = {};
    this.root.querySelectorAll('.tr-ch').forEach(function (c) { before[c.dataset.key] = c.dataset.state; });
    var wasPhase = this.root.dataset.phase;
    var url = window.location.pathname + '?section_id=' + encodeURIComponent(this.sid) + '&tr=' + Date.now();
    fetch(url, { credentials: 'same-origin' })
      .then(function (res) { if (!res.ok) throw new Error(res.status); return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.tr[data-section-id="' + self.sid + '"]');
        if (!fresh) throw new Error('sezione non trovata');
        var opened = [];
        fresh.querySelectorAll('.tr-ch').forEach(function (c) { if (c.dataset.state === 'open' && before[c.dataset.key] === 'lock') opened.push(c.dataset.key); });
        var changed = opened.length || fresh.dataset.phase !== wasPhase;
        if (!changed) { setTimeout(function () { self.reloading = false; }, 60000); return; }
        var hadFocus = self.root.contains(document.activeElement);
        self.destroy();
        self.root.replaceWith(fresh);
        var s = new Section(fresh, { reveal: opened });
        live[self.sid] = s;
        if (hadFocus) { var h = fresh.querySelector('h1'); if (h) { h.tabIndex = -1; h.focus({ preventScroll: true }); } }
        track('TrUnlock', { opened: opened.length });
      })
      .catch(function () { setTimeout(function () { self.reloading = false; }, 30000); });
  };

  /* ---------- iscrizione (Klaviyo client API) ---------- */
  Section.prototype.initForms = function () {
    var self = this, r = this.root;
    var key = r.dataset.klaviyoKey, list = r.dataset.klaviyoList;
    r.querySelectorAll('[data-tr-form]').forEach(function (f) {
      var input = f.querySelector('input[type=email]'), help = f.querySelector('.tr-help:not(.tr-priv)');
      if (self.subscribed) { f.classList.add('is-done'); help.textContent = 'Sei iscritto: ti scriviamo al prossimo sblocco.'; }
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        var v = input.value.trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) {
          f.classList.add('is-err'); input.setAttribute('aria-invalid', 'true');
          help.textContent = v ? 'Controlla l\'email: sembra incompleta.' : 'Scrivi la tua email per ricevere gli avvisi.';
          input.focus(); return;
        }
        f.classList.remove('is-err'); input.removeAttribute('aria-invalid');
        f.classList.add('is-busy'); help.textContent = 'Un attimo…';
        var done = function () {
          f.classList.remove('is-busy'); f.classList.add('is-done');
          help.textContent = 'Fatto. Ti scriviamo a ' + v + ' al prossimo sblocco.';
          self.subscribed = true; store.set('tr-sub', '1');
          r.querySelectorAll('[data-tr-form]').forEach(function (o) { if (o !== f) { o.classList.add('is-done'); o.querySelector('.tr-help:not(.tr-priv)').textContent = 'Sei iscritto: ti scriviamo al prossimo sblocco.'; } });
          self.updateSticky();
          track('Lead', { content_name: 'Three Roads waitlist' });
        };
        var fail = function () {
          f.classList.remove('is-busy'); f.classList.add('is-err');
          help.textContent = 'Non siamo riusciti a iscriverti. Riprova tra poco o scrivici a info@servati.it.';
        };
        if (!key || !list) { if (self.design) { done(); } else { fail(); } return; }
        fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(key), {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Three Roads landing',
                profile: { data: { type: 'profile', attributes: { email: v, properties: { three_roads_waitlist: true } } } }
              },
              relationships: { list: { data: { type: 'list', id: list } } }
            }
          })
        }).then(function (res) { if (res.status >= 200 && res.status < 300) done(); else fail(); }).catch(fail);
      });
    });
    r.querySelectorAll('[data-tr-ics]').forEach(function (b) {
      b.addEventListener('click', function () { self.downloadIcs(); b.textContent = 'Evento scaricato'; });
    });
  };

  Section.prototype.downloadIcs = function () {
    var d = new Date(this.drop * 1000), e = new Date((this.drop + 3600) * 1000);
    var z = function (x) { return x.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, ''); };
    var url = this.root.dataset.pageUrl;
    var ics = [
      'BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Servati//Three Roads//IT', 'CALSCALE:GREGORIAN',
      'BEGIN:VEVENT', 'UID:three-roads-' + this.drop + '@servati.it', 'DTSTAMP:' + z(new Date()),
      'DTSTART:' + z(d), 'DTEND:' + z(e), 'SUMMARY:Servati Three Roads: apre il drop',
      'DESCRIPTION:Il drop apre per tutti. ' + url, 'URL:' + url,
      'BEGIN:VALARM', 'TRIGGER:-PT15M', 'ACTION:DISPLAY', 'DESCRIPTION:Three Roads apre tra 15 minuti', 'END:VALARM',
      'END:VEVENT', 'END:VCALENDAR'
    ].join('\r\n');
    var a = document.createElement('a');
    a.href = URL.createObjectURL(new Blob([ics], { type: 'text/calendar' }));
    a.download = 'servati-three-roads.ics';
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(function () { URL.revokeObjectURL(a.href); }, 2000);
  };

  Section.prototype.focusForm = function () {
    var f = this.root.querySelector('[data-tr-form] input');
    if (!f) return;
    f.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'center' });
    setTimeout(function () { f.focus({ preventScroll: true }); }, RM ? 0 : 450);
  };

  /* ---------- video hero ---------- */
  Section.prototype.initHero = function () {
    var r = this.root, v = r.querySelector('.tr-hero-video');
    if (!v) return;
    this.heroVideo = v;
    var play = r.querySelector('[data-tr-hero-play]'), mute = r.querySelector('[data-tr-hero-mute]'), prog = r.querySelector('[data-tr-hero-prog]');
    var userPaused = RM, self = this;
    var sync = function () { play.classList.toggle('is-paused', v.paused); play.setAttribute('aria-label', v.paused ? 'Riproduci il video' : 'Metti in pausa il video'); };
    v.addEventListener('play', sync); v.addEventListener('pause', sync);
    v.addEventListener('timeupdate', function () { if (v.duration) prog.style.transform = 'scaleX(' + v.currentTime / v.duration + ')'; });
    play.addEventListener('click', function () { if (v.paused) { userPaused = false; v.play(); } else { userPaused = true; v.pause(); } });
    mute.addEventListener('click', function () {
      v.muted = !v.muted; mute.classList.toggle('is-sound', !v.muted); mute.setAttribute('aria-pressed', String(!v.muted));
      if (v.paused) { userPaused = false; v.play(); }
    });
    this.heroResume = function () { if (!userPaused) v.play().catch(function () {}); };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) self.heroResume(); else v.pause(); }); }, { threshold: 0.25 });
      io.observe(v); this.observers.push(io);
    } else if (!RM) { v.play().catch(function () {}); }
    sync();
  };

  /* ---------- barra fissa mobile ---------- */
  Section.prototype.initSticky = function () {
    var self = this, r = this.root;
    this.stick = r.querySelector('[data-tr-stick]');
    this.formSeen = true;
    var target = r.querySelector('.tr-hero [data-tr-form]') || r.querySelector('.tr-hero-live .tr-row');
    if (!this.stick || !target || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) { self.formSeen = es[0].isIntersecting || es[0].boundingClientRect.top > 0; self.updateSticky(); });
    io.observe(target); this.observers.push(io);
  };
  Section.prototype.updateSticky = function () {
    if (!this.stick) return;
    var drop = this.root.dataset.phase === 'drop';
    var on = !this.formSeen && (drop || !this.subscribed);
    this.stick.classList.toggle('is-on', on);
    this.stick.setAttribute('aria-hidden', String(!on));
    var a = this.stick.querySelector('a,button'); if (a) a.tabIndex = on ? 0 : -1;
  };

  /* ---------- lettore teaser ---------- */
  Section.prototype.initPlayer = function () {
    var self = this, r = this.root;
    var pl = r.querySelector('[data-tr-player]'); if (!pl) return;
    var v = pl.querySelector('[data-tr-pl-video]');
    var q = function (s) { return pl.querySelector(s); };
    var items = [].slice.call(r.querySelectorAll('[data-tr-teaser]'));
    var cur = 0, opener = null, caps = [];
    var pauseBtn = q('[data-tr-pl-pause]'), muteBtn = q('[data-tr-pl-mute]');
    if (!items.length) return;

    // stesso pulsante audio per tutta la sessione
    v.muted = true;

    function parseCaps(s) {
      return (s || '').split('\n').map(function (l) { var i = l.indexOf('|'); return i < 0 ? null : { t: parseFloat(l.slice(0, i)) || 0, x: l.slice(i + 1).trim() }; }).filter(Boolean).sort(function (a, b) { return a.t - b.t; });
    }
    function endCard() {
      var t = self.now(), it = items[cur], H = q('[data-tr-pl-end-h]'), P = q('[data-tr-pl-end-p]'), C = q('[data-tr-pl-cta]');
      var nextU = (self.cfg.next || []).filter(function (n) { return n.at > t; })[0];
      if (it.dataset.kind === 'impact' && self.root.dataset.phase === 'drop') {
        H.textContent = it.dataset.name; P.textContent = 'Il drop è aperto: scegli la tua strada.'; C.textContent = 'Scegli il tuo modello'; C.dataset.act = 'shop';
      } else if (self.root.dataset.phase === 'drop') {
        H.textContent = 'La scarpa di ' + it.dataset.name; P.textContent = 'Il modello è disponibile ora.'; C.textContent = 'Scegli il modello'; C.dataset.act = 'shop';
      } else if (cur < items.length - 1) {
        H.textContent = 'Poi c\'è ' + items[cur + 1].dataset.name; P.textContent = 'Il suo teaser è già sbloccato.'; C.textContent = 'Guarda ' + items[cur + 1].dataset.name; C.dataset.act = 'next';
      } else if (nextU) {
        var p = parts((nextU.at - t) * 1000);
        H.textContent = 'Il personaggio ' + pad(nextU.n) + ' si sblocca ' + (p.d >= 1 ? 'tra ' + p.d + (p.d === 1 ? ' giorno' : ' giorni') : 'tra ' + p.h + ' ore');
        P.textContent = 'Alle ' + hhmm(nextU.at) + ' di ' + weekday(nextU.at) + '. Il drop apre ' + (self.cfg.dropLabel || '') + '.';
        C.textContent = self.subscribed ? 'Sei iscritto' : 'Avvisami'; C.dataset.act = 'form'; C.disabled = self.subscribed;
      } else {
        H.textContent = 'Tre personaggi svelati'; P.textContent = 'Il drop apre ' + (self.cfg.dropLabel || '') + '.';
        C.textContent = self.subscribed ? 'Sei iscritto' : 'Avvisami'; C.dataset.act = 'form'; C.disabled = self.subscribed;
      }
      if (C.dataset.act !== 'form') C.disabled = false;
    }
    function load(i) {
      cur = i; var it = items[i];
      pl.classList.remove('is-ended');
      pl.classList.toggle('is-land', it.dataset.orientation === 'landscape');
      v.poster = it.dataset.poster || ''; v.src = it.dataset.src;
      q('[data-tr-pl-name]').textContent = it.dataset.name;
      q('[data-tr-pl-sub]').textContent = it.dataset.sub;
      q('[data-tr-pl-cap]').textContent = '';
      caps = parseCaps(it.dataset.captions);
      q('[data-tr-pl-prev]').disabled = i === 0;
      q('[data-tr-pl-next]').disabled = i === items.length - 1;
      v.play().catch(function () {});
      track('TrTeaserPlay', { name: it.dataset.name });
    }
    function open(i, btn) {
      opener = btn; pl.hidden = false; document.documentElement.classList.add('tr-lock');
      if (self.heroVideo) self.heroVideo.pause();
      load(i); q('[data-tr-pl-close]').focus();
    }
    function close() {
      v.pause(); v.removeAttribute('src'); v.load();
      pl.hidden = true; document.documentElement.classList.remove('tr-lock');
      if (self.heroResume) self.heroResume();
      if (opener) opener.focus();
    }
    items.forEach(function (b, i) { b.addEventListener('click', function () { open(i, b); }); });
    v.addEventListener('timeupdate', function () {
      if (!v.duration) return;
      q('[data-tr-pl-prog]').style.transform = 'scaleX(' + v.currentTime / v.duration + ')';
      var c = ''; caps.forEach(function (k) { if (v.currentTime >= k.t) c = k.x; });
      q('[data-tr-pl-cap]').textContent = c;
    });
    v.addEventListener('ended', function () { endCard(); pl.classList.add('is-ended'); q('[data-tr-pl-cta]').focus(); });
    v.addEventListener('play', function () { pauseBtn.classList.remove('is-paused'); pauseBtn.setAttribute('aria-label', 'Pausa'); });
    v.addEventListener('pause', function () { pauseBtn.classList.add('is-paused'); pauseBtn.setAttribute('aria-label', 'Riproduci'); });
    pauseBtn.addEventListener('click', function () { if (v.paused) v.play(); else v.pause(); });
    muteBtn.addEventListener('click', function () {
      v.muted = !v.muted; muteBtn.classList.toggle('is-sound', !v.muted);
      muteBtn.setAttribute('aria-pressed', String(!v.muted));
      muteBtn.setAttribute('aria-label', v.muted ? 'Attiva l\'audio' : 'Disattiva l\'audio');
    });
    q('[data-tr-pl-close]').addEventListener('click', close);
    q('[data-tr-pl-prev]').addEventListener('click', function () { if (cur > 0) load(cur - 1); });
    q('[data-tr-pl-next]').addEventListener('click', function () { if (cur < items.length - 1) load(cur + 1); });
    q('[data-tr-pl-again]').addEventListener('click', function () { pl.classList.remove('is-ended'); v.currentTime = 0; v.play(); });
    q('[data-tr-pl-cta]').addEventListener('click', function () {
      var act = this.dataset.act;
      if (act === 'next') { load(cur + 1); return; }
      close();
      if (act === 'shop') { var m = document.getElementById(self.cfg.productsAnchor); if (m) m.scrollIntoView({ behavior: RM ? 'auto' : 'smooth' }); }
      else self.focusForm();
    });
    pl.addEventListener('click', function (e) { if (e.target === pl) close(); });
    pl.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'ArrowRight') q('[data-tr-pl-next]').click();
      else if (e.key === 'ArrowLeft') q('[data-tr-pl-prev]').click();
      else if (e.key === 'Tab') {
        var f = [].slice.call(pl.querySelectorAll('button:not([disabled])')).filter(function (b) { return b.offsetParent !== null; });
        if (!f.length) return;
        var a = f[0], z = f[f.length - 1];
        if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
        else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
      }
    });
  };

    /* ---------- micro-interazione: pixel che seguono il cursore (desktop) / si muovono da soli (mobile) ----------
     Disegna il mosaico su canvas a partire dalla miniatura da 24/64 px già presente nella pagina:
     nessun dettaglio in più viene rivelato. Disattivata con "riduci movimento". Solo schede bloccate. */
  var FINE = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function PixelFx(media, src, anchor, after, cellTarget) {
    this.media = media; this.src = src; this.orig = src; this.anchor = anchor; this.cellTarget = cellTarget;
    this.cv = document.createElement('canvas');
    this.cv.className = 'tr-ch-fx';
    this.cv.setAttribute('aria-hidden', 'true');
    (after || src).insertAdjacentElement('afterend', this.cv);
    this.ctx = this.cv.getContext('2d');
    this.p = { x: 0.5, y: 0.5 };       // punto smussato (0..1)
    this.t = { x: 0.5, y: 0.5 };       // punto obiettivo
    this.s = 0; this.sT = 0;           // intensità attuale / obiettivo
    this.visible = false; this.raf = 0; this.clock = Math.random() * 100;
    this.resize();
    media.classList.add('has-fx');
    var self = this;
    if (FINE) {
      this.onMove = function (e) {
        var r = media.getBoundingClientRect();
        self.t.x = (e.clientX - r.left) / r.width; self.t.y = (e.clientY - r.top) / r.height;
        if (!self.sT) { self.p.x = self.t.x; self.p.y = self.t.y; }
        self.sT = 1; self.kick();
      };
      this.onLeave = function () { self.sT = 0; self.kick(); };
      media.addEventListener('pointermove', this.onMove);
      media.addEventListener('pointerleave', this.onLeave);
    } else {
      this.sT = 0.85;                  // su touch il punto si muove da solo
    }
  }
  PixelFx.prototype.resize = function () {
    var r = this.media.getBoundingClientRect(), d = Math.min(window.devicePixelRatio || 1, 2);
    this.W = r.width; this.H = r.height;
    this.cv.width = Math.round(r.width * d); this.cv.height = Math.round(r.height * d);
    this.ctx.setTransform(d, 0, 0, d, 0, 0);
    this.ctx.imageSmoothingEnabled = false;
    // box Impatto: ricampiona la miniatura in modo che i pixel abbiano la stessa misura dei capitoli
    var tc = this.cellTarget && this.cellTarget();
    if (tc) {
      var o = this.orig, nw = o.naturalWidth || o.width, nh = o.naturalHeight || o.height;
      var gw = Math.max(4, Math.round(this.W / tc)), gh = Math.max(4, Math.round(this.H / tc));
      var g = this.grid || (this.grid = document.createElement('canvas'));
      g.width = gw; g.height = gh;
      var gx = g.getContext('2d'), k = Math.max(gw / nw, gh / nh);
      gx.imageSmoothingEnabled = true;
      gx.drawImage(o, (gw - nw * k) / 2, (gh - nh * k) * this.anchor, nw * k, nh * k);
      this.src = g;
    }
    this.draw();
  
  };
  PixelFx.prototype.kick = function () {
    var self = this;
    if (this.raf || !this.visible) return;
    this.raf = requestAnimationFrame(function loop() {
      self.raf = 0;
      if (!FINE) {                     // percorso automatico lento
        self.clock += 1 / 60;
        self.t.x = 0.5 + 0.34 * Math.sin(self.clock * 0.55);
        self.t.y = 0.5 + 0.3 * Math.sin(self.clock * 0.41 + 1.3);
      }
      self.p.x += (self.t.x - self.p.x) * 0.14;
      self.p.y += (self.t.y - self.p.y) * 0.14;
      self.s += (self.sT - self.s) * 0.1;
      self.draw();
      var moving = Math.abs(self.t.x - self.p.x) + Math.abs(self.t.y - self.p.y) > 0.001 || Math.abs(self.sT - self.s) > 0.004 || !FINE;
      if (moving && self.visible) self.raf = requestAnimationFrame(loop);
    });
  };
  PixelFx.prototype.draw = function () {
    var img = this.src, nw = img.naturalWidth || img.width, nh = img.naturalHeight || img.height;
    if (!nw || !nh || !this.W) return;
    var c = this.ctx, W = this.W, H = this.H;
    var cell = Math.max(W / nw, H / nh);                 // stessa resa di object-fit: cover
    var ox = (W - nw * cell) / 2, oy = (H - nh * cell) * this.anchor;
    var px = this.p.x * W, py = this.p.y * H, R = Math.max(W, H) * 0.34, s = this.s;
    c.clearRect(0, 0, W, H);
    for (var gy = 0; gy < nh; gy++) {
      var y0 = oy + gy * cell; if (y0 > H || y0 + cell < 0) continue;
      for (var gx = 0; gx < nw; gx++) {
        var x0 = ox + gx * cell; if (x0 > W || x0 + cell < 0) continue;
        var cx = x0 + cell / 2, cy = y0 + cell / 2, dx = cx - px, dy = cy - py;
        var dist = Math.sqrt(dx * dx + dy * dy), f = s > 0.01 ? Math.max(0, 1 - dist / R) : 0;
        f = f * f * (3 - 2 * f) * s;                    // smoothstep
        var push = f * cell * 0.55, k = 1 - f * 0.42, sz = cell * k + 0.5;
        var ux = dist ? dx / dist : 0, uy = dist ? dy / dist : 0;
        var x = cx + ux * push - sz / 2, y = cy + uy * push - sz / 2;
        c.drawImage(img, gx, gy, 1, 1, x, y, sz, sz);
        if (f > 0.02) { c.fillStyle = 'rgba(236,234,229,' + (f * 0.28).toFixed(3) + ')'; c.fillRect(x, y, sz, sz); }
      }
    }
  };
  PixelFx.prototype.destroy = function () {
    cancelAnimationFrame(this.raf); this.raf = 0;
    if (this.onMove) { this.media.removeEventListener('pointermove', this.onMove); this.media.removeEventListener('pointerleave', this.onLeave); }
    this.media.classList.remove('has-fx'); this.cv.remove();
  };

  Section.prototype.initPixelFx = function () {
    if (RM) return;
    var self = this; this.fx = [];
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
      es.forEach(function (e) { var fx = e.target.__trFx; if (!fx) return; fx.visible = e.isIntersecting; if (fx.visible) fx.kick(); });
    }, { rootMargin: '100px' }) : null;
    if (io) this.observers.push(io);
    this.root.querySelectorAll('.tr-ch[data-state="lock"] .tr-ch-m').forEach(function (m) {
      var img = m.querySelector('.tr-ch-px');
      if (!img) return;
      var start = function () {
        // dimensioni reali della miniatura: con il srcset il browser riporta una larghezza "corretta" falsa
        var probe = new Image();
        probe.src = img.currentSrc || img.src;
        probe.decode().then(function () {
          if (!probe.naturalWidth || probe.naturalWidth > 200) return;
          var wide = !!m.closest('.tr-ch-wide');
          var target = wide ? function () {
            var ref = self.root.querySelector('.tr-ch:not(.tr-ch-wide) .tr-ch-m');
            return ref ? ref.getBoundingClientRect().width / 24 : 0;
          } : null;
          var fx = new PixelFx(m, probe, wide ? 0.5 : 0.18, img, target);
          m.__trFx = fx; self.fx.push(fx);
          if (io) io.observe(m); else { fx.visible = true; fx.kick(); }
        }).catch(function () {});
      };
      if (img.complete && img.naturalWidth) start(); else img.addEventListener('load', start, { once: true });
    });
    var rt = 0;
    this.onResize = function () { clearTimeout(rt); rt = setTimeout(function () { self.fx.forEach(function (f) { f.resize(); }); }, 120); };
    window.addEventListener('resize', this.onResize);
    this.onVis = function () { self.fx.forEach(function (f) { if (document.hidden) { cancelAnimationFrame(f.raf); f.raf = 0; } else f.kick(); }); };
    document.addEventListener('visibilitychange', this.onVis);
  };

  /* ---------- avvio (anche dentro l'editor del tema) ---------- */
  var live = {};
  function boot(scope) {
    (scope || document).querySelectorAll('.tr[data-section-id]').forEach(function (root) {
      var id = root.dataset.sectionId;
      if (live[id] && live[id].root === root) return;
      if (live[id]) live[id].destroy();
      live[id] = new Section(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('.tr[data-section-id]');
    if (root && live[root.dataset.sectionId]) { live[root.dataset.sectionId].destroy(); delete live[root.dataset.sectionId]; }
  });
})();
